export default "__VITE_ASSET__CQyny_$R__"